import { ProcessWithStatus } from "processList/model/ProcessWithStatus";
import { rowsPerPageKey } from "processList/model/RowsPerPage";
import { visibleProcessListColumnsKey, visibleSubprocessListColumnsKey } from "processList/model/VisibleColumnsStore";
import { HashMap } from "shared/model/HashMap";
import { Utilities } from "shared/utilities";

export const DO_NOT_USE_hiddenColumnKey = "processinstance_hidden_columns";
const removeProcessInstanceHiddenColumnsKeyFromLocalStorage = () => {
    try {
        const value = localStorage.getItem(DO_NOT_USE_hiddenColumnKey)
        if (!value) {
            return;
        }
        localStorage.removeItem(DO_NOT_USE_hiddenColumnKey)
    } catch (e) {
        console.error(e);
    }
}

const removeLatestExecutionStateFromLocalStorageVisibleColumns = () => {
    try {
        const processListTypeWithVisibleColumns: HashMap<string | null> = {
            [visibleProcessListColumnsKey]: localStorage.getItem(visibleProcessListColumnsKey),
            [visibleSubprocessListColumnsKey]: localStorage.getItem(visibleSubprocessListColumnsKey)
        }

        const processListTypeWithVisibleColumnsMapping = Object.entries(processListTypeWithVisibleColumns);

        for (const listType in processListTypeWithVisibleColumnsMapping) {
            const listTypeWithVisibleColumns = processListTypeWithVisibleColumnsMapping[listType];
            const visibleColumns = listTypeWithVisibleColumns[1];
            const columnType = listTypeWithVisibleColumns[0];
            if (visibleColumns?.includes("latestExecutionState")) {
                const parsedColumns: Array<keyof (ProcessWithStatus)> = JSON.parse(visibleColumns);
                const filteredWithoutExecutionState = parsedColumns.filter((f) => f !== "latestExecutionState");
                localStorage.setItem(columnType, JSON.stringify(filteredWithoutExecutionState));
            }
        }
    } catch (e) {
        console.error(e);
    }
}

const updateUnlimitedRowsPerPageValueLocalStorage = () => {
    try {
        const rowsPerPage = localStorage.getItem(rowsPerPageKey);
        if (!rowsPerPage) {
            return;
        }
        if (Number(rowsPerPage) === 0) {
            localStorage.setItem(rowsPerPageKey, String(Utilities.unlimitedPageSize));
        }
    } catch (e) {
        console.error(e);
    }
}

const migrations = [
    removeProcessInstanceHiddenColumnsKeyFromLocalStorage,
    removeLatestExecutionStateFromLocalStorageVisibleColumns,
    updateUnlimitedRowsPerPageValueLocalStorage
];

export const executeMigrations = () => {
    for (const migration of migrations) {
        migration.call(this)
    }
}